import { render } from "./AposTiptapStyles.vue?vue&type=template&id=1dbed9e7&scoped=true"
import script from "./AposTiptapStyles.vue?vue&type=script&lang=js"
export * from "./AposTiptapStyles.vue?vue&type=script&lang=js"

import "./AposTiptapStyles.vue?vue&type=style&index=0&id=1dbed9e7&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbed9e7"],['__file',"rich-text-widget/ui/apos/components/AposTiptapStyles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dbed9e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dbed9e7', __exports__)) {
    api.reload('1dbed9e7', __exports__)
  }
  
  module.hot.accept("./AposTiptapStyles.vue?vue&type=template&id=1dbed9e7&scoped=true", () => {
    api.rerender('1dbed9e7', render)
  })

}


export default __exports__